// Land unit conversion library. All units are normalized to square metres (m²).
// Values chosen using widely-accepted North Indian (UP) standards.

export const UNITS = [
  { key: "sqft", label: "Square Feet", short: "sq ft", perSqm: 1 / 0.09290304 },
  { key: "sqyd", label: "Square Yard (Gaj)", short: "sq yd", perSqm: 1 / 0.83612736 },
  { key: "sqm", label: "Square Metre", short: "m²", perSqm: 1 },
  { key: "acre", label: "Acre", short: "ac", perSqm: 1 / 4046.8564224 },
  { key: "hectare", label: "Hectare", short: "ha", perSqm: 1 / 10000 },
  { key: "dismil", label: "Dismil (Decimal)", short: "dismil", perSqm: 1 / 40.468564 },
  { key: "bigha", label: "Bigha (UP)", short: "bigha", perSqm: 1 / 2529.2848 },
  { key: "biswa", label: "Biswa (UP)", short: "biswa", perSqm: 1 / 126.4642 },
  { key: "katha", label: "Katha", short: "katha", perSqm: 1 / 126.4642 },
  { key: "marla", label: "Marla", short: "marla", perSqm: 1 / 25.29285 },
  { key: "kanal", label: "Kanal", short: "kanal", perSqm: 1 / 505.857 },
  { key: "guntha", label: "Guntha", short: "guntha", perSqm: 1 / 101.17141 },
  { key: "cent", label: "Cent", short: "cent", perSqm: 1 / 40.468564 },
];

export const UNITS_BY_KEY = Object.fromEntries(UNITS.map((u) => [u.key, u]));

// Convert `value` from `fromKey` to `toKey`
export function convert(value, fromKey, toKey) {
  const v = Number(value);
  if (!isFinite(v) || v === 0) return 0;
  const inSqm = v / UNITS_BY_KEY[fromKey].perSqm;
  return inSqm * UNITS_BY_KEY[toKey].perSqm;
}

export function convertAll(value, fromKey) {
  const v = Number(value);
  if (!isFinite(v)) return {};
  const out = {};
  for (const u of UNITS) out[u.key] = convert(v, fromKey, u.key);
  return out;
}

export function formatNumber(n, maxFraction = 4) {
  if (n === 0) return "0";
  if (!isFinite(n)) return "—";
  const abs = Math.abs(n);
  if (abs >= 1e9) return n.toExponential(3);
  if (abs >= 1000) return n.toLocaleString("en-IN", { maximumFractionDigits: 2 });
  if (abs >= 1) return n.toLocaleString("en-IN", { maximumFractionDigits: maxFraction });
  return n.toLocaleString("en-IN", { maximumFractionDigits: 6 });
}

export function formatINR(n) {
  if (!isFinite(n)) return "₹0";
  return "₹" + Math.round(n).toLocaleString("en-IN");
}
